import React from 'react'

import { Trash2Icon } from 'lucide-react'
import { makeObservable } from 'mobx'
import { observer } from 'mobx-react'

import { Button } from '~/client/src/shared/components/Button/Button'
import StruxhubInput from '~/client/src/shared/components/StruxhubInputs/StruxhubInput'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import MapViewSetUpStore from '../../views/ProjectSetUp/components/AppsSitemap/MapViewSetUp.store'

interface IProps {
  store: MapViewSetUpStore
}

const remoteTilesetProperties = 'Remote tileset properties'

@observer
export default class RemoteTilesetProperties extends React.Component<IProps> {
  public constructor(props: IProps) {
    super(props)
    makeObservable(this)
  }

  public render(): React.ReactNode {
    return (
      <div className="full-height scrollable">
        <div className="col py10">
          <div className="row pb12 bb-light-input-border">
            <div className="text header bold center">
              {remoteTilesetProperties}
            </div>
          </div>
          {this.renderSelectedTilesetProperties()}
        </div>
      </div>
    )
  }

  private renderSelectedTilesetProperties(): JSX.Element {
    const { remoteTilesetsSetupStore } = this.props.store
    const {
      selectedRemoteTileset,
      showDeleteConfirmationDialogByRemoteTileset,
    } = remoteTilesetsSetupStore

    if (!selectedRemoteTileset) {
      return null
    }

    return (
      <div className="col pa10 bb-light-cool-grey">
        <div className="row pa10 x-end">
          <Button
            variant="destructive-ghost"
            size="icon-xs"
            className="tw:flex-none!"
            aria-label={Localization.translator.delete}
            onClick={showDeleteConfirmationDialogByRemoteTileset.bind(
              this,
              selectedRemoteTileset,
            )}
          >
            <Trash2Icon />
          </Button>
        </div>
        <div className="relative">
          <StruxhubInput
            label={Localization.translator.name}
            type="string"
            value={selectedRemoteTileset.name}
            isReadOnly
            isRequiredTextHidden
            hideBottomLabel
          />
        </div>
        <div className="relative">
          <StruxhubInput
            label="Source URL"
            type="string"
            value={selectedRemoteTileset.source}
            isReadOnly
            isRequiredTextHidden
            hideBottomLabel
          />
        </div>
      </div>
    )
  }
}
